import { NgModule } from '@angular/core';
import { ButtonToggleGroupFormComponent } from './button-toggle-group-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonToggleGroupModule } from '../button-toggle-group/button-toggle-group.module';

@NgModule({
  imports: [ReactiveFormsModule, ButtonToggleGroupModule],
  providers: [],
  declarations: [ButtonToggleGroupFormComponent],
  exports: [ButtonToggleGroupFormComponent],
})
export class ButtonToggleGroupFormModule {}
